import * as React from "react";
import { styled } from "@mui/system";
import MUIInput from "@mui/material/Input";
import { InputProps as InputPropsMUI } from "@mui/material/Input";
export interface InputProps extends InputPropsMUI {}

const InputRoot = styled(MUIInput, {
  name: "Input",
  slot: "Root",
  overridesResolver: (props, styles) => []
})(({ theme }) => ({}));

export const Input = React.forwardRef<HTMLDivElement, InputProps>(
  function Input(props, ref) {
    return <InputRoot {...props} ref={ref} />;
  }
) as React.FC<InputProps>;
